import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, FileQuestion, HelpCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-white" data-id="element-126">
      <div className="container mx-auto px-4" data-id="element-127">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-129">
            Drowning in data, starving for insights?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-130">
            Wearables collect millions of data points, but most apps just show
            you raw numbers without context.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-131">
          {[{
          icon: BarChart3,
          title: 'Too Many Metrics',
          description: "Steps, HRV, SpO2, Sleep Stages... it's overwhelming to know what actually matters for your health today."
        }, {
          icon: FileQuestion,
          title: 'No Personal Baseline',
          description: 'Is a heart rate of 70 good or bad? Without knowing your personal normal, the number is meaningless.'
        }, {
          icon: HelpCircle,
          title: 'Zero Interpretation',
          description: "Apps show you graphs but don't tell you what to do. You're left guessing how to improve."
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-slate-50 rounded-2xl p-8 border border-slate-100 hover:border-teal-100 hover:shadow-lg transition-all duration-300 group" data-id="element-132">
              <div className="h-12 w-12 bg-white rounded-xl shadow-sm flex items-center justify-center text-slate-400 group-hover:text-teal-600 group-hover:scale-110 transition-all duration-300 mb-6 border border-slate-100" data-id="element-133">
                <item.icon className="h-6 w-6" data-id="element-134" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-135">
                {item.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-136">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}